import { Spinner } from '@optiaxiom/react';

import { useToolLoadingState } from './hooks';
import { RegistryStatusToggle } from './RegistryStatusToggle';
import { ToolStatusToggle } from './ToolStatusToggle';
import type { StatusCellProps } from './types';

export function StatusCell({
  toolRow,
  onToggleActive,
  onBulkToggle,
  isUpdating,
  updatingToolId,
  isUpdatingEnabledInPrimaryAgent,
  updatingToolIdEnabledInPrimaryAgent,
  isBulkToggling,
}: StatusCellProps) {
  const isLoading = useToolLoadingState(
    toolRow,
    isUpdating,
    updatingToolId,
    isUpdatingEnabledInPrimaryAgent,
    updatingToolIdEnabledInPrimaryAgent
  );

  if (toolRow.isRegistry) {
    return (
      <RegistryStatusToggle
        toolRow={toolRow}
        onBulkToggle={onBulkToggle}
        isLoading={isBulkToggling}
      />
    );
  }

  if (isLoading) {
    return <Spinner size="xs" />;
  }

  return <ToolStatusToggle tool={toolRow.tool} onToggleActive={onToggleActive} />;
}
